module.exports = __webpack_public_path__ + "img/744.fe3b6c35.jpg";